<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="grades_headers"
        :items="grades_items"
        class="elevation-1"
        :loading="gradesLoading"
        loading-text="Загружаю данные"
        item-key="GRADE_ID"
        show-select
        single-select
        :search="gradeSearch"
        dense
        :value="value"
        @input="setValue"
        :items-per-page="5"
        :footer-props="{
          itemsPerPageText: 'На страницу',
          itemsPerPageAllText: 'Все',
          pageText: 'из'
        }"
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Список топлив</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="gradeSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'refGradesLocalTable',
  props: ['value', 'GOST'],
  data () {
    return {
      grades_headers: [
        {
          text: 'ГОСТ',
          value: 'GOST.GOST_CODE'
        },
        {
          text: 'Наименование',
          value: 'GRADE_NAME'
        },
        {
          text: 'Код',
          value: 'GRADE_CODE'
        },
        {
          text: 'ОКПД',
          value: 'OKPD.OKPD_ID'
        }
      ],
      gradesLoading: false,
      gradeSearch: '',
      grades_items: []
    }
  },

  computed: {},
  watch: {
    value (val) {
      if (!val || !val.length || !val[0].GRADE_ID) return
      const curr = this.grades_items.findIndex(itm => itm.GRADE_ID === val[0].GRADE_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.grades_items.splice(curr, 1)
          this.setValue([])
          return
        }
        this.grades_items.splice(curr, 1, val[0])
      } else {
        this.grades_items.push(val[0])
      }
    },
    GOST (val, prevVal) {
      if (prevVal) {
        this.getGradesList()
      }
    }
  },
  mounted: function () {
    console.log('refGradesLocalTable mounted')
    if (this.grades_items.length === 0) {
      this.getGradesList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getGradesList () {
      const self = this
      this.gradesLoading = true
      const payload = { ...this.GOST }
      if (!payload.GOST_ID) { payload.GOST_ID = -5 }
      axios({
        url: '/api/org/references/getFG2GOSTList.php',
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.grades_items.splice(0, self.grades_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка топлив: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка топлив: \n ${err}` })
        })
        .finally(
          this.gradesLoading = false
        )
    }
  }
}

</script>
